(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["supfix-autumn-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('supfix-autumn-offer')) {
    customElements.define('supfix-autumn-offer', class extends HTMLElement {
      connectedCallback() {
        this.update = () => {
          const now = Date.now() / 1000;
          const start = Number(this.dataset.start);
          const end = Number(this.dataset.end);
          const phase = now < start ? 'pre' : now < end ? 'live' : 'ended';
          this.dataset.phase = phase;
          this.querySelectorAll('[data-sfa-phase]').forEach(node => { node.hidden = !node.dataset.sfaPhase.split(' ').includes(phase); });
          const seconds = Math.max(0, Math.ceil((phase === 'pre' ? start : end) - now));
          const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
          Object.entries(values).forEach(([unit, value]) => { const node = this.querySelector(`[data-sfa-unit="${unit}"]`); if(node) node.textContent = String(value).padStart(2, '0'); });
        };
        this.update();
        this.interval = setInterval(this.update, 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
